"use client";

import { useEffect, useRef } from "react";

// Zlicza odsłonę artykułu raz na mount (deduplikacja po stronie serwera —
// cookie 24h). Wywołanie z klienta, nie z SSR, żeby odświeżenie strony
// (nowy request serwerowy) nie naliczało kolejnych wyświetleń.
export default function BlogViewTracker({ slug }: { slug: string }) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    fetch(`/api/blog/posts/${slug}/view`, { method: "POST" }).catch(() => {});
  }, [slug]);

  return null;
}
